// extracted by mini-css-extract-plugin
export default {"headerLink":"LogoLink_headerLink__hz7-N","headerLink_logo":"LogoLink_headerLink_logo__xsYBG"};